import { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import BotonContacto from "./BotonContacto";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      {/* Botón hamburguesa */}
      <button 
        className="menu-toggle" 
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        ☰
      </button>

      {/* Links */}
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li><Link to="/home">Home</Link></li>
        <li><Link to="/Aplicativos">Aplicativos</Link></li>
        <li><Link to="/about">Sobre nosotros</Link></li>
        <li><BotonContacto>{(link) =>
              link ? (
                <a href={link.url} target="_blank" rel="noreferrer">
                  Contáctame
                </a>
              ) : (
                <span>Contáctame</span>
              )
            }</BotonContacto></li>
      </ul>
    </nav>
  );
}

export default Navbar;
